/* Progressive navigation: content and native forms remain usable without JS. */
(() => {
  const initialize = root => {
    root.querySelectorAll('.efx-page--cms').forEach(page => {
      if (page.dataset.editorialReady) return;
      page.dataset.editorialReady = 'true';
      const prose = page.querySelector('.efx-prose');
      if (!prose) return;
      if (prose.querySelector('.efgl,.efpf')) page.classList.add('efx-page--illustrated');
      // Existing specialist navigation takes precedence; do not duplicate it.
      if (prose.querySelector('nav,.efgl-toc,.efpf-nav,form')) return;
      const headings = [...prose.querySelectorAll(':scope > h2,:scope > section > h2')]
        .filter(h => h.textContent.trim() && !h.closest('details'));
      if (headings.length < 4) return;
      const toc = document.createElement('details');
      toc.className = 'efx-page-toc';
      const summary = document.createElement('summary'); summary.textContent = 'On this page';
      const nav = document.createElement('nav'); nav.setAttribute('aria-label','On this page');
      const list = document.createElement('ol');
      headings.forEach((heading,index) => {
        if (!heading.id) {
          const base = 'page-section-' + (index + 1); let id = base, n = 1;
          while (document.getElementById(id)) id = base + '-' + (++n);
          heading.id = id;
        }
        const item = document.createElement('li'); const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id); link.textContent = heading.textContent.trim();
        item.append(link); list.append(item);
      });
      nav.append(list); toc.append(summary,nav); prose.before(toc);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(document),{once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();

/* Quiet entry for informational headings only. Text is never hidden; this is
   optional movement, not a prerequisite for reading or using the page. */
(() => {
  if (!window.matchMedia || !window.IntersectionObserver || !Element.prototype.animate) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selectors = [
    'body.efx.template-page #efx-main .efx-page--cms .efx-prose > h2',
    'body.efx.template-page #efx-main .efx-page--cms .efx-prose > section > h2',
    'body.template-page-about-us #efx-main .ef-about__section-h',
    'body.template-page-contact-us #efx-main .ef-cu-side > h2',
    'body.template-page-faq #efx-main .ef-faq-section__title',
    'body.template-page-trade-program #efx-main .ef-pro-perk > h3'
  ].join(',');
  const excluded = 'form,dialog,details,nav,[role="dialog"],[role="tablist"],.efm,.efgl,.efpf,.ef-cfg,[data-efw-step]';
  const seen = new WeakSet();
  const running = new Map();
  let observer;

  function safeTarget(element) {
    if (element.closest(excluded) || !element.getClientRects().length) return false;
    // Never transform a container holding a control, sticky element or fixed UI.
    if (element.querySelector('form,input,select,textarea,button,a,iframe,video,canvas,[tabindex],[contenteditable]')) return false;
    const nodes = [element, ...element.querySelectorAll('*')];
    if (nodes.some(node => {
      const style = getComputedStyle(node);
      return style.position === 'fixed' || style.position === 'sticky';
    })) return false;
    // Existing page motion owns its elements; do not layer another animation.
    for (let node = element; node && node.id !== 'efx-main'; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.visibility !== 'visible' || Number(style.opacity) !== 1 || style.transform !== 'none' || style.animationName !== 'none') return false;
    }
    return true;
  }

  function cancelAll() {
    if (observer) observer.disconnect();
    running.forEach(animation => animation.cancel());
    running.clear();
  }

  function initialize() {
    if (preference.matches) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const element = entry.target;
        observer.unobserve(element);
        if (preference.matches || !safeTarget(element)) return;
        try {
          const animation = element.animate(
            [{ transform: 'translateY(8px)' }, { transform: 'translateY(0)' }],
            { duration: 320, easing: 'cubic-bezier(.2,.65,.3,1)', iterations: 1, fill: 'none' }
          );
          animation.id = 'efx-editorial-entry';
          running.set(element, animation);
          animation.finished.then(() => running.delete(element), () => running.delete(element));
        } catch (_) { /* Reading remains unchanged if animation is unavailable. */ }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -32px 0px' });
    document.querySelectorAll(selectors).forEach(element => {
      if (seen.has(element) || !safeTarget(element)) return;
      seen.add(element);
      observer.observe(element);
    });
  }

  const changed = () => { if (preference.matches) cancelAll(); else initialize(); };
  if (preference.addEventListener) preference.addEventListener('change', changed);
  else if (preference.addListener) preference.addListener(changed);
  document.addEventListener('focusin', event => {
    running.forEach((animation, element) => {
      if (element === event.target || element.contains(event.target)) animation.cancel();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pagehide', cancelAll);
})();
